module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_her2st.16944881.png";